<section class="campaign-list-page">

    <div class="campaign-page-header">
        <div>
          <h1>Campañas EST</h1>
          <p>
            Registro de atenciones realizadas durante las campañas de ABAQ.
          </p>
        </div>
      
        <div class="campaign-header-actions">
          <button
            type="button"
            class="copy-form-button"
            (click)="copyCampaignFormLink()"
          >
            🔗 Copiar formulario
          </button>
      
          @if (!showCreateForm) {
            <button
              type="button"
              class="create-campaign-button"
              (click)="openCreateForm()"
            >
              + Nueva campaña
            </button>
          }
        </div>
      </div>
  
    @if (showCreateForm) {
  
      <div class="campaign-form-card">
  
        <div class="campaign-form-header">
  
          <div>
            <h2>Nueva campaña</h2>
  
            <p>
              Registra la información de la atención realizada.
            </p>
          </div>
  
          <button
            type="button"
            class="close-form-button"
            (click)="closeCreateForm()"
          >
            ×
          </button>
  
        </div>
  
        <div class="campaign-form-section">
  
          <h3>Información del responsable</h3>
  
          <div class="campaign-form-grid">
  
            <div class="campaign-form-group">
              <label for="responsibleName">
                Nombre del responsable *
              </label>
  
              <input
                id="responsibleName"
                type="text"
                [(ngModel)]="newCampaign.responsibleName"
                placeholder="Nombre completo"
              />
            </div>
  
            <div class="campaign-form-group">
              <label for="responsibleAge">
                Edad
              </label>
  
              <input
                id="responsibleAge"
                type="number"
                min="0"
                [(ngModel)]="newCampaign.responsibleAge"
                placeholder="Edad"
              />
            </div>
  
            <div class="campaign-form-group">
              <label for="responsibleGender">
                Sexo
              </label>
  
              <input
                id="responsibleGender"
                type="text"
                [(ngModel)]="newCampaign.responsibleGender"
                placeholder="Sexo"
              />
            </div>
  
            <div class="campaign-form-group">
              <label for="email">
                Correo
              </label>
  
              <input
                id="email"
                type="email"
                [(ngModel)]="newCampaign.email"
                placeholder="correo@ejemplo.com"
              />
            </div>
  
            <div class="campaign-form-group">
              <label for="phone">
                Teléfono
              </label>
  
              <input
                id="phone"
                type="text"
                [(ngModel)]="newCampaign.phone"
                placeholder="Número telefónico"
              />
            </div>
  
            <div class="campaign-form-group">
              <label for="municipality">
                Municipio
              </label>
  
              <input
                id="municipality"
                type="text"
                [(ngModel)]="newCampaign.municipality"
                placeholder="Municipio"
              />
            </div>
  
            <div class="campaign-form-group">
              <label for="neighborhood">
                Colonia
              </label>
  
              <input
                id="neighborhood"
                type="text"
                [(ngModel)]="newCampaign.neighborhood"
                placeholder="Colonia"
              />
            </div>
  
            <div class="campaign-form-group">
              <label for="street">
                Calle
              </label>
  
              <input
                id="street"
                type="text"
                [(ngModel)]="newCampaign.street"
                placeholder="Calle y número"
              />
            </div>
  
          </div>
  
        </div>
  
        <div class="campaign-form-section">
  
          <h3>Información de la mascota</h3>
  
          <div class="campaign-form-grid">
  
            <div class="campaign-form-group">
              <label for="petName">
                Nombre de la mascota *
              </label>
  
              <input
                id="petName"
                type="text"
                [(ngModel)]="newCampaign.petName"
                placeholder="Nombre de la mascota"
              />
            </div>
  
            <div class="campaign-form-group">
              <label for="species">
                Especie *
              </label>
  
              <select
                id="species"
                [(ngModel)]="newCampaign.species"
              >
                <option value="DOG">Perro</option>
                <option value="CAT">Gato</option>
              </select>
            </div>
  
            <div class="campaign-form-group">
              <label for="petGender">
                Sexo
              </label>
  
              <input
                id="petGender"
                type="text"
                [(ngModel)]="newCampaign.petGender"
                placeholder="Sexo"
              />
            </div>
  
            <div class="campaign-form-group">
              <label for="breed">
                Raza
              </label>
  
              <input
                id="breed"
                type="text"
                [(ngModel)]="newCampaign.breed"
                placeholder="Raza"
              />
            </div>
  
            <div class="campaign-form-group">
              <label for="size">
                Tamaño
              </label>
  
              <input
                id="size"
                type="text"
                [(ngModel)]="newCampaign.size"
                placeholder="Tamaño"
              />
            </div>
  
            <div class="campaign-form-group">
              <label for="petAge">
                Edad
              </label>
  
              <input
                id="petAge"
                type="number"
                min="0"
                [(ngModel)]="newCampaign.petAge"
                placeholder="Edad"
              />
            </div>
  
            <div class="campaign-form-group">
              <label for="weight">
                Peso (kg)
              </label>
  
              <input
                id="weight"
                type="number"
                min="0"
                step="0.1"
                [(ngModel)]="newCampaign.weight"
                placeholder="Peso"
              />
            </div>
  
          </div>
  
        </div>
  
        <div class="campaign-form-section">
  
          <h3>Información de ABAQ</h3>
  
          <div class="campaign-form-grid">
  
            <div class="campaign-form-group">
              <label for="payment">
                Forma de pago
              </label>
  
              <input
                id="payment"
                type="text"
                [(ngModel)]="newCampaign.payment"
                placeholder="Forma de pago"
              />
            </div>
  
            <div class="campaign-form-group">
              <label for="howDidYouHearAboutAbaq">
                ¿Cómo conoció ABAQ?
              </label>
  
              <input
                id="howDidYouHearAboutAbaq"
                type="text"
                [(ngModel)]="newCampaign.howDidYouHearAboutAbaq"
                placeholder="Evento, redes, referido..."
              />
            </div>
  
            <div class="campaign-form-group">
              <label for="socialNetwork">
                Red social
              </label>
  
              <input
                id="socialNetwork"
                type="text"
                [(ngModel)]="newCampaign.socialNetwork"
                placeholder="Instagram, Facebook..."
              />
            </div>
  
            <div class="campaign-form-group">
              <label for="socialAccount">
                Cuenta social
              </label>
  
              <input
                id="socialAccount"
                type="text"
                [(ngModel)]="newCampaign.socialAccount"
                placeholder="@usuario"
              />
            </div>
  
          </div>
  
          <label class="campaign-checkbox">
            <input
              type="checkbox"
              [(ngModel)]="newCampaign.recommendedAbaqOnSocialMedia"
            />
  
            <span>
              Recomendó ABAQ en redes sociales
            </span>
          </label>
  
        </div>
  
        <div class="campaign-form-section">
  
          <h3>Información de la atención</h3>
  
          <div class="campaign-form-grid">
  
            <div class="campaign-form-group">
              <label for="sterilizationDate">
                Fecha de esterilización
              </label>
  
              <input
                id="sterilizationDate"
                type="date"
                [(ngModel)]="newCampaign.sterilizationDate"
              />
            </div>
  
            <div class="campaign-form-group">
              <label for="sterilizationLocation">
                Lugar de esterilización
              </label>
  
              <input
                id="sterilizationLocation"
                type="text"
                [(ngModel)]="newCampaign.sterilizationLocation"
                placeholder="Lugar"
              />
            </div>
  
            <div class="campaign-form-group">
              <label for="campaignType">
                Tipo de campaña
              </label>
  
              <input
                id="campaignType"
                type="text"
                [(ngModel)]="newCampaign.campaignType"
                placeholder="Esterilización..."
              />
            </div>
  
            <div class="campaign-form-group">
              <label for="veterinarian">
                Veterinario
              </label>
  
              <input
                id="veterinarian"
                type="text"
                [(ngModel)]="newCampaign.veterinarian"
                placeholder="Nombre del veterinario"
              />
            </div>
  
          </div>
  
          <div class="campaign-form-group campaign-comments-group">
  
            <label for="comments">
              Comentarios
            </label>
  
            <textarea
              id="comments"
              rows="4"
              [(ngModel)]="newCampaign.comments"
              placeholder="Comentarios adicionales..."
            ></textarea>
  
          </div>
  
        </div>
  
        <div class="campaign-form-actions">
  
          <button
            type="button"
            class="cancel-campaign-button"
            (click)="closeCreateForm()"
          >
            Cancelar
          </button>
  
          <button
            type="button"
            class="save-campaign-button"
            [disabled]="
              isCreatingCampaign ||
              !newCampaign.responsibleName ||
              !newCampaign.petName ||
              !newCampaign.species
            "
            (click)="createCampaign()"
          >
            {{ isCreatingCampaign ? 'Guardando...' : 'Guardar campaña' }}
          </button>
  
        </div>
  
      </div>
  
    }
  
    @if (isLoading) {
  
      <div class="loading-state">
        <p>Cargando campañas...</p>
      </div>
  
    }
  
    @if (!isLoading && !campaigns.length) {
  
      <div class="empty-state">
        <p>
          No hay campañas registradas todavía.
        </p>
      </div>
  
    }
  
    @if (!isLoading && campaigns.length) {
  
      <div class="campaign-list">
  
        @for (
          campaign of pagedCampaigns;
          track campaign._id
        ) {
  
          <article class="campaign-card">
  
            <div class="campaign-card-header">
  
              <div>
                <h2>
                  {{ campaign.petName }}
                </h2>
  
                <p>
                  Responsable: {{ campaign.responsibleName }}
                </p>
              </div>
  
              <span
                class="species-badge"
                [class.cat-badge]="campaign.species === 'CAT'"
              >
                {{ campaign.species === 'DOG' ? 'Perro' : 'Gato' }}
              </span>
  
            </div>
  
            <div class="campaign-card-info">
  
              <div>
                <span>Fecha de esterilización</span>
  
                <strong>
                  {{
                    campaign.sterilizationDate
                      ? (campaign.sterilizationDate | date:'mediumDate':'UTC')
                      : '—'
                  }}
                </strong>
              </div>
  
              <div>
                <span>Tipo de campaña</span>
  
                <strong>
                  {{ campaign.campaignType || '—' }}
                </strong>
              </div>
  
              <div>
                <span>Ubicación</span>
  
                <strong>
                  {{ campaign.sterilizationLocation || '—' }}
                </strong>
              </div>
  
              <div>
                <span>Veterinario</span>
  
                <strong>
                  {{ campaign.veterinarian || '—' }}
                </strong>
              </div>
  
            </div>
  
            <div class="campaign-card-footer">
  
              <span>
                {{ campaign.breed || 'Raza no especificada' }}
                ·
                {{ campaign.petAge ?? '—' }} años
              </span>
  
              <button
                type="button"
                class="view-campaign-button"
                (click)="viewCampaign(campaign._id)"
              >
                Ver detalles
              </button>
  
            </div>
  
          </article>
  
        }
  
      </div>

      <app-pagination
        [(page)]="page"
        [totalItems]="campaigns.length"
        [pageSize]="pageSize"
      ></app-pagination>
  
    }
  
  </section>